import { type FC } from 'react';
import CustomParallaxImage from './components/CustomParallaxImage';
import { Background, ImageContainer } from './styled';

const CallToAction: FC = () => {
  return (
    <Background>
      <ImageContainer>
        <CustomParallaxImage />
      </ImageContainer>
    </Background>
  );
};

export default CallToAction;
